import {NgModule} from "@angular/core";
import {DataTablesModule} from "angular-datatables";
import {DynamicFormModule} from "../dynamic-form/dynamic-form.module";
import {ListingComponent, } from "./listing/listing.component";
import {DetailComponent} from "./detail/detail.component";
import {SharedModule} from "../../shared.module";
import {MyCheckModule} from '../my-check/my-check.module';
import {DatatableEditableModule} from "../datatable-editable/datatable-editable.module";
import {AssignmentsModule} from "../assignments/assignments.module";
import { TabsModule } from "../tabs/tabs.module";
import { ReducedDetailComponent } from './reduced-detail/reduced-detail.component';
import { CompanyLookupComponent } from "./company-lookup/company-lookup.component";

@NgModule({
  declarations: [
      ListingComponent,
	  DetailComponent,
	  ReducedDetailComponent,
	  CompanyLookupComponent,
  ],
  imports: [
      DataTablesModule,
      DynamicFormModule,
	  SharedModule,
      MyCheckModule,
	  DatatableEditableModule,
      AssignmentsModule,
      TabsModule
	]
})
export class ContentsModule {} // end class ContentsModule
